@if (showOverlay()) {
  <div class="bootstrap-overlay tw:fixed tw:flex tw:items-center tw:justify-center"
    [class.has-error]="isBootstrapErrored()">
    <div class="overlay-content tw:flex tw:flex-col tw:items-center tw:justify-center tw:text-center">
      <!-- Loading State -->
      @if (isBootstrapLoading() || isAnyResourceLoading()) {
        <div class="loading-state tw:flex tw:flex-col tw:items-center"
          role="status"
          aria-live="polite">
          <ion-spinner name="circular"
            class="spinner"></ion-spinner>
          <h2>{{ 'bootstrap.initializing' | translate }}</h2>
          <p class="status-text">{{ 'bootstrap.loading' | translate }}</p>
        </div>
      }

      <!-- Error State -->
      @if (isBootstrapErrored()) {
        <div class="error-state tw:flex tw:flex-col tw:items-center"
          role="alert">
          <div class="error-icon tw:flex tw:items-center tw:justify-center">
            <ion-icon name="alert-circle"></ion-icon>
          </div>
          <h2>{{ 'bootstrap.errorTitle' | translate }}</h2>
          <p class="error-message">{{ errorMessageKey() | translate }}</p>
          <p class="error-hint">{{ 'bootstrap.errorHint' | translate }}</p>
          <ion-button
            (click)="retry()"
            class="retry-button">
            {{ 'bootstrap.retry' | translate }}
          </ion-button>
        </div>
      }
    </div>
  </div>
}
